module.exports = __webpack_public_path__ + "img/ClickForSound_37.5f3b7f75.png";